import { MdDoneAll, MdOutlineHandshake, MdOutlineInsights, MdOutlineLocalShipping } from "react-icons/md";
import Footer from "./Footer";


export default function Values() {
  const values = [
    {
      icon: <MdOutlineHandshake size={22} />,
      title: "Our Commitment",
      text: "Professional execution, reliable delivery, and measurable value on every project.",
    },
    {
      icon: <MdOutlineInsights size={22} />,
      title: "Our Philosophy",
      text: "We reduce delays and procurement complexity through clear, responsive support.",
    },
    {
      icon: <MdOutlineLocalShipping size={22} />,
      title: "What We Deliver",
      text: "Construction materials and transportation services aligned to project timelines.",
    },
    {
      icon: <MdDoneAll size={22} />,
      title: "Who We Serve",
      text: "Developers, hospitality, NGOs, corporate teams, and individual homeowners.",
    },
  ];

  return (
  <>
    <section className="about-center-values-wrap mb-5" style={{width:"90%", marginLeft:"5%", marginTop:"10%"}} id="about-values">
      <div className="about-center-head">
        <p className="about-center-eyebrow font-bold fs-4">OUR CORE VALUES</p>
        <h3 className="font-bold about-center-section-title">Built on reliability, clarity, and delivery</h3>
      </div>
      <div className="about-center-values">
        {values.map((value, index) => (
          <article key={index} className="about-center-value-card" style={{ animationDelay: `${index * 0.08}s` }}>
            <div className="about-center-value-icon">{value.icon}</div>
            <h6 className="font-bold about-center-value-title">{value.title}</h6>
            <p className="about-center-value-text m-0">{value.text}</p>
          </article>
        ))}
      </div>

      <style>{`
          .modern-about-page {
            padding: 64px 0;
            background:
              radial-gradient(circle at 14% 8%, rgba(181, 217, 246, 0.22), transparent 40%),
              linear-gradient(180deg, #f7fbff 0%, #ffffff 80%);
          }

          .about-center-eyebrow {
            font-size: 32px;
            letter-spacing: 1.2px;
            color: var(--primaryColor);
            margin-bottom: 8px;
            font-weight: "bold"
          }

          .about-center-hero {
            max-width: 980px;
            margin: 0 auto 18px;
            text-align: center;
            border-radius: 24px;
            border: 1px solid rgba(84, 132, 170, 0.17);
            background: linear-gradient(150deg, #ffffff 0%, #f7fbff 100%);
            box-shadow: 0 15px 34px rgba(17, 45, 67, 0.08);
            padding: 34px 26px 24px;
            scroll-margin-top: calc(var(--topBarHeight) + 20px);
          }

          .about-center-title {
            max-width: 820px;
            margin: 0 auto 14px;
            font-size: 24px;
            line-height: 1.13;
          }

          .about-center-text {
            max-width: 780px;
            margin: 0 auto 10px;
            font-size: 16px;
            line-height: 1.75;
            color: rgba(31, 48, 62, 0.9);
          }

          .about-center-logo {
            width: min(92%, 340px);
            margin: 20px auto 0;
            border: 1px solid rgba(95, 147, 188, 0.2);
            border-radius: 16px;
            background: linear-gradient(160deg, #ffffff, #eef6ff);
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .about-center-logo img {
            width: min(100%, 300px);
            height: auto;
            object-fit: contain;
            animation: aboutFloat 3s ease-in-out infinite;
          }

          .about-center-head {
            max-width: 860px;
            margin: 0 auto 14px;
            text-align: center;
          }

          .about-center-section-title {
            margin: 0;
            font-size: 24px;
            line-height: 1.2;
          }

          .about-center-values-wrap,
          .about-center-why-work {
            border-radius: 22px;
            border: 1px solid rgba(84, 132, 170, 0.15);
            background: #ffffff;
            box-shadow: var(--shadow1);
            padding: 24px 18px;
            margin-bottom: 14px;
            scroll-margin-top: calc(var(--topBarHeight) + 20px);
          }

          .about-center-values {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
          }

          .about-center-value-card {
            border-radius: 16px;
            border: 1px solid rgba(0, 29, 251, 0.08);
            background: linear-gradient(180deg, #ffffff, #fbfdff);
            padding: 16px;
            animation: aboutReveal 0.5s ease both;
          }

          .about-center-value-icon {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(140deg, var(--primaryColor), var(--secondaryColor));
            color: #ffffff;
            margin-bottom: 10px;
          }

          .about-center-value-title {
            font-size: 18px;
            margin-bottom: 6px;
          }

          .about-center-value-text {
            font-size: 14px;
            line-height: 1.6;
            opacity: 0.86;
          }

          .about-center-why-work {
            background: linear-gradient(140deg, #0f2f56, #194a84);
            color: #ffffff;
            box-shadow: 0 16px 34px rgba(9, 36, 66, 0.26);
          }

          .about-center-why-work .about-center-eyebrow {
            color: #9fe3ff;
          }

          .about-center-why-text {
            max-width: 850px;
            margin: 10px auto 0;
            font-size: 15px;
            line-height: 1.75;
            opacity: 0.94;
          }

          .about-center-why-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
            max-width: 980px;
            margin: 14px auto 0;
          }

          .about-center-why-point {
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(255, 255, 255, 0.08);
            border-radius: 12px;
            padding: 10px;
            display: flex;
            gap: 10px;
            align-items: flex-start;
          }

          .about-center-why-index {
            min-width: 38px;
            text-align: center;
            border-radius: 999px;
            padding: 4px 8px;
            font-size: 12px;
            background: rgba(255, 255, 255, 0.16);
            color: #ffffff;
          }

          .about-center-why-point-text {
            font-size: 14px;
            line-height: 1.6;
            opacity: 0.96;
          }

          @keyframes aboutFloat {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-8px);
            }
          }

          @keyframes aboutReveal {
            from {
              opacity: 0;
              transform: translateY(12px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @media (max-width: 1199px) {
            .about-center-values {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 991px) {
            .about-center-why-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 767px) {
            .modern-about-page {
              padding: 52px 0;
            }

            .about-center-hero {
              padding: 24px 14px 18px;
              border-radius: 16px;
            }

            .about-center-values-wrap,
            .about-center-why-work {
              border-radius: 16px;
              padding: 16px 12px;
            }

            .about-center-values {
              grid-template-columns: 1fr;
            }
          }
        `}</style>

    </section>
    <Footer/>
  </>
  );
}
